import { render, staticRenderFns } from "./AdminEditKunde.vue?vue&type=template&id=55e859ce&scoped=true&"
import script from "./AdminEditKunde.vue?vue&type=script&lang=js&"
export * from "./AdminEditKunde.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditKunde.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdminEditKunde.vue?vue&type=style&index=1&id=55e859ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e859ce",
  null
  
)

export default component.exports